const GRATICULE_SOURCE_ID = 'graticule';
const GRATICULE_LAYER_ID = 'graticule-lines';

function getGraticuleInterval(zoom) {
  if (zoom >= 14) return 0.005;
  if (zoom >= 12) return 0.01;
  if (zoom >= 10) return 0.05;
  if (zoom >= 8) return 0.1;
  if (zoom >= 6) return 0.5;
  if (zoom >= 4) return 1;
  if (zoom >= 2) return 5;
  return 10;
}

function buildGraticuleGeoJson(map) {
  const bounds = map.getBounds();
  const zoom = map.getZoom();
  const interval = getGraticuleInterval(zoom);

  const west = Math.floor(bounds.getWest() / interval) * interval;
  const east = Math.ceil(bounds.getEast() / interval) * interval;
  const south = Math.max(
    -85,
    Math.floor(bounds.getSouth() / interval) * interval
  );
  const north = Math.min(
    85,
    Math.ceil(bounds.getNorth() / interval) * interval
  );

  const features = [];

  for (let lng = west; lng <= east + 1e-9; lng += interval) {
    features.push({
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [lng, -85],
          [lng, 85]
        ]
      },
      properties: { kind: 'meridian', value: lng }
    });
  }

  for (let lat = south; lat <= north + 1e-9; lat += interval) {
    features.push({
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [-180, lat],
          [180, lat]
        ]
      },
      properties: { kind: 'parallel', value: lat }
    });
  }

  return { type: 'FeatureCollection', features };
}

export function addGraticule() {
  if (!this.map) return;

  if (!this.map.getSource(GRATICULE_SOURCE_ID)) {
    this.map.addSource(GRATICULE_SOURCE_ID, {
      type: 'geojson',
      data: buildGraticuleGeoJson(this.map)
    });
  }

  if (!this.map.getLayer(GRATICULE_LAYER_ID)) {
    this.map.addLayer({
      id: GRATICULE_LAYER_ID,
      type: 'line',
      source: GRATICULE_SOURCE_ID,
      paint: {
        'line-color': 'rgba(0,0,0,0.3)',
        'line-width': 0.7,
        'line-dasharray': [5, 4]
      }
    });
  }

  this._graticuleHandler = () => {
    const source = this.map && this.map.getSource(GRATICULE_SOURCE_ID);
    if (source) source.setData(buildGraticuleGeoJson(this.map));
  };
  this.map.on('moveend', this._graticuleHandler);
  this.map.on('zoomend', this._graticuleHandler);

  this._graticuleCursorEnter = () => {
    this.map.getCanvas().style.cursor = 'crosshair';
  };
  this._graticuleCursorLeave = () => {
    this.map.getCanvas().style.cursor = '';
  };
  this.map.on('mouseenter', GRATICULE_LAYER_ID, this._graticuleCursorEnter);
  this.map.on('mouseleave', GRATICULE_LAYER_ID, this._graticuleCursorLeave);
}

export function removeGraticule() {
  if (!this.map) return;

  if (this._graticuleHandler) {
    this.map.off('moveend', this._graticuleHandler);
    this.map.off('zoomend', this._graticuleHandler);
    this._graticuleHandler = null;
  }

  if (this._graticuleCursorEnter) {
    this.map.off('mouseenter', GRATICULE_LAYER_ID, this._graticuleCursorEnter);
    this.map.off('mouseleave', GRATICULE_LAYER_ID, this._graticuleCursorLeave);
    this._graticuleCursorEnter = null;
    this._graticuleCursorLeave = null;
  }

  if (this.map.getLayer(GRATICULE_LAYER_ID)) {
    this.map.removeLayer(GRATICULE_LAYER_ID);
  }
  if (this.map.getSource(GRATICULE_SOURCE_ID)) {
    this.map.removeSource(GRATICULE_SOURCE_ID);
  }
}
